import React from 'react';
import { Navbar } from '../components/barber/Navbar';
import { Hero } from '../components/barber/Hero';
import { Services } from '../components/barber/Services';
import { Testimonials } from '../components/barber/Testimonials';
import { Difference } from '../components/barber/Difference';
import { LocationHours } from '../components/barber/LocationHours';
import { FinalCTA } from '../components/barber/FinalCTA';
import { BookingToast } from '../components/barber/BookingToast';
export function BarberLanding() {
  return <div className="w-full min-h-screen bg-[#0d0d0d]" data-id="element-318">
      <Navbar data-id="element-319" />
      <main data-id="element-320">
        <Hero data-id="element-321" />
        <Services data-id="element-322" />
        <Testimonials data-id="element-323" />
        <Difference data-id="element-324" />
        <LocationHours data-id="element-325" />
        <FinalCTA data-id="element-326" />
      </main>
      <BookingToast data-id="element-327" />
    </div>;
}